<template>
    <DefaultLayout :meta="meta">

        <div class="w-full max-w-screen-xl mx-auto px-6 mb-16">
       
            <h1 class="text-2xl font-bold mt-8">
            	{{ page.title }}
            </h1>

            <div class="grid lg:grid-cols-2 gap-12">

                <div class="mt-8" v-html="page.content"></div>

                <div>

                    <Alert v-if="$page.props.flash.success">
                        {{ $page.props.flash.success }}
                    </Alert>

                    <form @submit.prevent="submit" v-else>

                        <FormGroup :label="__('admin::labels.name')" :error="errors.name">
                            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" autocomplete="name" />
                        </FormGroup>

                        <FormGroup :label="__('admin::labels.email')" :error="errors.email">
                            <Input name="email" type="email" :has-error="exists(errors.email)" v-model="form.email" :required="true" autocomplete="email" />
                        </FormGroup>

                        <FormGroup :label="__('admin::labels.message')" :error="errors.message">
                            <Textarea name="message" :has-error="exists(errors.message)" v-model="form.message" rows="4" :required="true" />
                        </FormGroup>

                        <Button type="submit">
                            {{ __('home::contact.send_message') }}
                            <ChevronRightIcon class="h-6 w-6 ml-1" />
                        </Button>

                    </form>

                </div>

            </div>

        </div>
        
    </DefaultLayout>
</template>

<script>
    import {
        ChevronRightIcon,
    } from '@heroicons/vue/solid'

    export default {
        components: {
            ChevronRightIcon,
        },
        props: {
            meta: {
                type: Object,
                default: () => {},
            },
            page: {
                type: Object,
                default: () => {},
            },
            errors: {
                type: Object,
                default: () => {},
            },
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: '',
                    email: '',
                    message: '',
                }),
            }
        },
        methods: {
            submit() {
                this.form
                    .post(this.$route('home::contact.store'));
            },
        },
    }
</script>